module.exports = __webpack_public_path__ + "static/media/przemiana4_right.7bd25222.jpeg";